import TokenService from "@/data/services/token.service"
import {AuthService} from "@/data/services/auth.service";
import {AccountService} from "../../data/services/account.service";

const token = TokenService.getLocalAccessToken();

const initialState = token ?
  { status: { loggedIn: true }, token } :
  { status: { loggedIn: false }, token: null };

export const auth = {
  namespaced: true,
  state: {
    ...initialState,
    user: null
  },
  actions: {
    login({commit}, user) {
      console.log('login dispatched', user);
      const authService = new AuthService();
      return authService.login(user).then(
        response => {
          commit('loginSuccess', response);
          return Promise.resolve(response);
        },
        error => {
          console.log('error at vuex')
          // const payload = {
          //   accessToken: 'token',
          //   refreshToken: 'refreshtoken',
          // };
          // commit('loginSuccess', payload);
          commit('loginFailure');
          return Promise.reject(error);
        }
      )
    },
    getOwnProfile({commit}) {
      console.log('getOwnProfile dispatched');
      const accountService = new AccountService();
      return accountService.getUserProfile().then(
        response => {
          commit('setOwnProfile', response);
          return Promise.resolve(response);
        },
        error => {
          console.log('error at vuex')
          return Promise.reject(error);
        }
      )
    },
    logout({ commit }) {
      const authService = new AuthService();
      authService.logout();
      commit('logout');
    },
    register({ commit }, user) {
      const authService = new AuthService();
      return authService.register(user).then(
        response => {
          commit('registerSuccess');
          return Promise.resolve(response.data);
        },
        error => {
          commit('registerFailure');
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {
    loginSuccess(state, token) {
      console.log('login success mutate', token);
      TokenService.setLocalAccessToken(token);
      state.status.loggedIn = true;
      state.token = token;
    },
    setOwnProfile(state, payload) {
      console.log('setOwnProfile success mutate', payload);
      state.user = payload;
    },
    loginFailure(state) {
      state.status.loggedIn = false;
      state.token = null;
    },
    logout(state) {
      state.status.loggedIn = false;
      state.token = null;
    },
    registerSuccess(state) {
      state.status.loggedIn = false;
    },
    registerFailure(state) {
      state.status.loggedIn = false;
    }
  },
  getters: {
    getLoggedInState(state) {
      return state.status.loggedIn
    },
    getUserDetailState(state) {
      return state.user
    }
  }
}
